<template>
  <div class="border">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-position="right" label-width="10px">
      <el-form-item label=" ">
        <el-input v-model="searchForm.queryValue" width="500px" placeholder="搜索（xx策略名称或code）"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="pageIndex=1;list();">搜索</el-button>
      </el-form-item>
      <el-form-item style="float: right;padding-right: 30px" >
        <el-button type="primary" icon="el-icon-plus" @click="showAddFlag = true">新增策略</el-button>
      </el-form-item>
    </el-form>
    <template>
      <el-table ref="componentTable" :data="tableData" border stripe highlight-current-row @selection-change="handleSelectionChange">
        <el-table-column prop="name" label="策略名称" header-align="center" align="center" />
        <el-table-column prop="code" label="策略编号" header-align="center" align="center" />
        <el-table-column prop="updatedAt" label="最近修改" header-align="center" align="center"/>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button @click="copyStrategy(scope.row)" type="primary" plain size="mini">拷贝</el-button>
            <el-button @click="editStrategy(scope.row)" type="primary" plain size="mini">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="->,total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </template>
    <!--子组件-->
    <add :ifshow="showAddFlag"  @handleCloseDialog="showAddFlag=false;list();"></add>
    <copy :ifshow="showCopyFlag" :strategy="strategy" @handleCloseDialog="showCopyFlag=false;list();"></copy>
  </div>
</template>

<script>
// import {clone} from '@/utils/common'

export default {
  props: {
  },
  data () {
    return {
      searchForm: {
        queryValue: null
      },
      tableData: [],
      strategy: {},
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      selectIds: [],
      showAddFlag: false,
      showCopyFlag: false
    }
  },
  created () {
    this.list()
  },
  methods: {
    editStrategy (row) {
      this.$router.push({path: `/strategy-edit/${row.code}/${row.version}`})
    },
    copyStrategy (row) {
      // todo 查询最新的策略信息
      this.strategy = row
      this.showCopyFlag = true
    },
    async list () {
      console.log(process.env)
      let params = {
        ...this.searchForm,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      try {
        const res = await this.$http.post('/strategy/list', params)
        if (res.code === '200') {
          this.tableData = res.data.rows
          this.total = res.data.total
        } else {
          this.$message.error(res.message)
        }
      } catch (err) {
        console.error(err)
      }
    },
    handleCurrentChange (currentPage) {
      this.pageIndex = currentPage
      this.list()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.list()
    },
    handleSelectionChange (val) {
      this.selectIds = []
      val.forEach(v => {
        this.selectIds.push(v.id)
      })
    }
  },
  components: {
    'add': () => import('./add'),
    'copy': () => import('./copy')
  }
}
</script>

<style scoped lang="stylus">

</style>



// WEBPACK FOOTER //
// src/views/homepage/list.vue